var _desc, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMiddleMEmpty(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "75px",
    height: "21px",
    viewBox: "0 0 75 21",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Rectangle Copy 8") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Onboarding",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Company_Q2_M",
    transform: "translate(-190.000000, -78.000000)",
    fill: "#EEEEEE"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-6-Copy-4",
    transform: "translate(54.000000, 77.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M137.146422,1.12568102 L199.929406,1.12568102 C200.189607,1.12568102 200.439561,1.22710103 200.626197,1.40840656 L209.890772,10.4084066 C210.286911,10.7932335 210.296082,11.426332 209.911255,11.8224718 C209.904527,11.8293982 209.897698,11.8362268 209.890772,11.8429555 L200.626197,20.8429555 C200.439561,21.024261 200.189607,21.125681 199.929406,21.125681 L137.146422,21.125681 C136.594138,21.125681 136.146422,20.6779658 136.146422,20.125681 C136.146422,19.8503566 136.259938,19.5872127 136.460208,19.3982813 L144.458263,11.8530808 C144.859995,11.4740953 144.878435,10.8411989 144.499449,10.4394671 C144.486123,10.4253415 144.472389,10.4116071 144.458263,10.3982813 L136.460208,2.85308077 C136.058477,2.47409527 136.040037,1.84119885 136.419023,1.43946706 C136.607954,1.23919615 136.871098,1.12568102 137.146422,1.12568102 Z",
    id: "Rectangle-Copy-8"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMiddleMEmpty);
export default __webpack_public_path__ + "static/media/middleMEmpty.8e26a0f84dbe77acfb53bc0e4c5f871d.svg";
export { ForwardRef as ReactComponent };